import type { Component } from '../../../services/aiConfigService';

export const getFormInitialValues = (editing?: Component | null) => {
  if (!editing) {
    return {
      thinkingModes: [],  // 确保初始值是数组
    };
  }
  
  // 处理来源字段：serviceName:pageId:componentId
  const source = editing.serviceName && editing.pageId && editing.componentId
    ? `${editing.serviceName}:${editing.pageId}:${editing.componentId}`
    : '';
  
  // 处理思考方式关联数据（只保留思考方式ID数组）
  const thinkingModes = editing.thinkingModes?.map((tm: any) => {
    // 如果是对象，提取 thinkingModeId
    if (typeof tm === 'object' && tm !== null) {
      return tm.thinkingModeId || tm.thinkingMode?.id || tm.id;
    }
    // 如果已经是字符串，直接返回
    return tm;
  }).filter(Boolean) || [];

  return {
    ...editing,
    source,
    thinkingModes: Array.isArray(thinkingModes) ? thinkingModes : [],
  };
};
